<!-- 2 columns form -->
<form name="transactionform" [formGroup]="transactionForm" novalidate>
  <div class="panel panel-flat">
    <div class="panel-heading">
      <h5 class="panel-title">Add Transaction</h5>
      <div class="heading-elements">
        <ul class="icons-list">
          <li>
            <a data-action="reload" ng-click="mainService.reload()"></a>
          </li>
        </ul>
      </div>
      <hr class="divider">
    </div>

    <div class="panel-body">

      <div class="row">
        <div class="col-md-5">
          <fieldset>
            <legend class="text-semibold">
              <i class="icon-reading position-left"></i> Transaction Specs
            </legend>

            <div class="row">
              <div class="col-md-6">

                <div class="form-group required">
                  <span class="control-label">Equb: </span>
                  <ng-select [items]="ekubs" placeholder="" formControlName="ekub" bindValue="id" bindLabel="text"
                    (change)="getEkubMembers()" required>
                  </ng-select>
                  <div class="help-block" *ngIf="ekub.invalid && (ekub.dirty || ekub.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i> Equb is required
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <span class="control-label">Member: </span>
                  <ng-select [items]="ekubMembers" placeholder="" formControlName="user" bindLabel="id" bindLabel="text"
                  (change)="setSelectedMember(user.value)">
                  </ng-select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Transaction Date: </span>
                  <input type="date" name="transaction_date" formControlName="transaction_date"
                    placeholder="transaction date" class="form-control">
                  <div class="help-block"
                    *ngIf="transaction_date.invalid && (transaction_date.dirty || transaction_date.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i> Transaction Date is required
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Bank: </span>
                  <select name="bank" required formControlName="bank" class="form-control"
                    data-placeholder="Select bank">
                    <option selected disabled>Bank:</option>
                    <option *ngFor="let bank of banks" value="{{bank.accronym}}">{{bank.bank}}</option>
                  </select>
                  <div class="help-block" *ngIf="bank.invalid && (bank.dirty || bank.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Bank is required.
                    </p>
                  </div>
                </div>
              </div>

            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Transaction Number: </span>
                  <input type="text" name="transaction_number" required formControlName="transaction_number"
                    placeholder="Tranaction Number as shown in the receipt" class="form-control">
                  <div class="help-block"
                    *ngIf="transaction_number.invalid && (transaction_number.dirty || transaction_number.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i> Transaction Number is required
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label"> Amount: </span>
                  <input type="text" name="amount" formControlName="amount"
                    placeholder="Minimum amount before completion" class="form-control" required>
                  <div class="help-block" *ngIf="amount.invalid && (amount.dirty || amount.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 tx-red position-left"></i> Amount is required
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Type: </span>
                  <select name="type" required formControlName="type" class="form-control"
                    data-placeholder="Select payment type">
                    <option selected disabled>Transaction Type:</option>
                    <option value="deposit">Deposit</option>
                    <option value="fine">Fine</option>
                    <option value="award">Award</option>
                  </select>
                  <div class="help-block" *ngIf="type.invalid && (type.dirty || type.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Payment type is required
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Status: </span>
                  <select name="status" required formControlName="status" class="form-control"
                    data-placeholder="Select transaction status">
                    <option selected disabled>Status:</option>
                    <option value="pending">Pending</option>
                    <option value="confirmed">Confirmed</option>
                  </select>
                  <div class="help-block" *ngIf="status.invalid && (status.dirty || status.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Transaction status is required.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>&nbsp;</label>
                  <label>Remark:</label>
                  <textarea rows="5" cols="5" class="form-control" name="remark" formControlName="remark"
                    placeholder="Remark . . ."></textarea>
                  <div class="help-block" *ngIf="remark.invalid && (remark.dirty || remark.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Please write small description about the
                      transaction
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </fieldset>
        </div>

        <div class="col-md-7">
          <fieldset>
            <legend class="text-semibold">
              <i class="icon-camera position-left"></i> Transaction Detais
            </legend>



          </fieldset>
        </div>

      </div>

      <div class="text-right">

        <!--  <button class="btn bg-slate-800" (click)="addNews(transaction.id)" type="submit" data-style="slide-right" [ladda]="isLoading" [disabled]="newsForm.invalid">
          <span *ngIf="!transaction.id">Save News</span>
          <span *ngIf="transaction.id">Update News</span>
          <i class="icon-floppy-disk position-right"></i>
        </button> -->
        <button class="btn bg-slate-800" (click)="addTransaction()" type="submit" data-style="slide-right"
          [disabled]="transactionForm.invalid">
          <span *ngIf="operation=='add'">Save Transaction</span>
          <span *ngIf="operation!='add'">Update Transaction</span>
          <i class="icon-floppy-disk position-right"></i>
        </button>
      </div>

    </div>
  </div>
</form>
<!-- /2 columns form -->